import { TLCLogger } from "../../../../js/lib/logger";
import { ApplicationData } from "../ApplicationData";
import { PrintBase } from "./PrintBase";

export class PrintBib extends PrintBase {
  constructor() {
    super({
      dataTitle: ApplicationData.language.bibliography,
      divID: "citations",
      style: "MLA",
      docName: ApplicationData.language.bibliography,
    });
  }

  getTemplateTypeFromFormat(
    template,
    format
  ) {
    const type = format.toLowerCase().replace(/ /g, "_").replace("/", "_");
    const match = template.find("p[type*=" + type + "]");
    return match.length > 0 ? type : null;
  }

  getTemplateTypeFromImageDisplays(template, imageDisplays) {
    for (const display of imageDisplays) {
      // naturally sorted most specific to least specific
      const type = this.getTemplateTypeFromFormat(
        template,
        display.imageType
      );
      if (type) {
        return type;
      }
    }
    return null;
  }

  getBibliographyType(
    resource,
    template
  ) {
    const { format = "", imageDisplays = [], rtype } = resource;
    const RSS_TYPE = 2;
    const typeFromFormat = this.getTemplateTypeFromFormat(template, format);
    if (typeFromFormat) {
      return typeFromFormat;
    }

    const typeFromImageDisplays = this.getTemplateTypeFromImageDisplays(
      template,
      imageDisplays
    );
    if (typeFromImageDisplays) {
      return typeFromImageDisplays;
    }

    return rtype === RSS_TYPE ? "rss" : "unknown";
  }


  print(list, newStyle) {
    var _this = this;

    this.list = list;

    this.style = newStyle || this.style;

    this.getXML(function (template) {
      //we want to send it a copy of the array
      //otherwise it will end up sorting the order and
      //we don't want that
      _this.resourceList = list.resources.slice();
      _this.sortList(_this.resourceList, template);

      var html = _this.buildExportData(_this.resourceList, template);

      _this.buildHTML(html.html());

      _this.loadData();
    });
  }
  getXML(callback) {
    var _this = this;

    if (!_this.templates[_this.style]) {
      $.ajax({
        type: "GET",
        url: "tmpl/bibExports/" + _this.style.toLowerCase() + ".xml",
        dataType: "xml",
        success: function (xml) {
          _this.templates[_this.style] = $(xml);
          callback(_this.templates[_this.style]);
        },
      });
    } else {
      callback(_this.templates[_this.style]);
    }
  }
  sortList(resources, template) {
    var _this = this;

    $.each(resources, function (index, resource) {

      //Set The Sort Key
      const type = _this.getBibliographyType(resource, template);

      var temp = template.find("p[type*=" + type + "]").children();
      var primary = temp[0].attributes.getNamedItem("class").value;
      var secondary = temp[1].attributes.getNamedItem("class").value;

      var author = resource.shortAuthor.trim();
      var title = resource.shortTitle.trim();

      if (
        (primary == "author" && author.length > 0) ||
        (primary == "title" && title.length === 0)
      ) {
        resource.sortKey = resource.shortAuthor;
      } else {
        resource.sortKey = resource.shortTitle;
      }
    });

    //Sort the List based on the SortKey
    resources.sort(function (a, b) {
      var x = a.sortKey.toLowerCase();
      var y = b.sortKey.toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });

    _this.resourceList = resources;
  }
  buildExportData(resourceList, template) {
    var _this = this;

    var dataHolder = $("<div></div>");
    $.each(resourceList, function (index, resource) {
      if (resource.rtype == 1) {
        var shortAuthor = resource.shortAuthor.trim();

        if (shortAuthor.length > 0 && !shortAuthor.match(/\.$/)) {
          shortAuthor += ".";
        }

        var shortTitle = resource.shortTitle.trim();
        if (shortTitle.length > 0 && !shortTitle.match(/\.$/)) {
          shortTitle += ".";
        }

        var pubPlace = "";
        var pubName = "";
        var pubDate = "";

        if (resource.publicationInformations.length > 0) {
          pubPlace = resource.publicationInformations[0].publicationPlace.trim();
          if (pubPlace.length > 0 && !pubPlace.match(/:$/)) {
            pubPlace += ":";
          }
          pubName = resource.publicationInformations[0].publisherName.trim();
          if (pubName.length > 0 && !pubName.match(/,$/)) {
            pubName += ",";
          }
          pubDate = resource.publicationInformations[0].publicationDate.trim();
          if (pubDate.length > 0 && !pubDate.match(/\.$/)) {
            pubDate += ".";
          }
        }

        var group = "";
        var webAddress = "";
        if (resource.rtype == 2) {
          group = resource.rssFeedName;
          webAddress = "<" + resource.link + ">";
        }

        const type = _this.getBibliographyType(resource, template);

        var bib = template.find("p[type*=" + type + "]").clone();
        bib.attr("class", "citation");
        bib.find("span[class=author]").text(shortAuthor);
        bib.find("span[class=title]").text(shortTitle);
        bib.find("span[class=group]").text(group);
        bib.find("span[class=format]").text(resource.format + ".");
        bib.find("span[class=issue]").text(""); //NOT CURRENLTY SUPPORTED
        bib.find("span[class=pages]").text(resource.extent);
        bib.find("span[class=place]").text(pubPlace);
        bib.find("span[class=location]").text(pubName);
        bib.find("span[class=date]").text(pubDate);
        bib.find("span[class=url]").text(webAddress);

        try {
          dataHolder.append(bib);
        } catch (e1) {
          //IE can't append an XML doc to an HTML doc.  Need to convert it first
          try {
            bib = $(bib[0].xml);
            dataHolder.append(bib);
          } catch (e2) {
            TLCLogger.error("Error:", e2);
            throw e2;
          }
        }
      }
    });
    return dataHolder;
  }
}
